import { render, staticRenderFns } from "./ShopHospitalCategoryTable.vue?vue&type=template&id=5b9a1532&scoped=true&"
import script from "./ShopHospitalCategoryTable.vue?vue&type=script&lang=js&"
export * from "./ShopHospitalCategoryTable.vue?vue&type=script&lang=js&"
import style0 from "./ShopHospitalCategoryTable.vue?vue&type=style&index=0&id=5b9a1532&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b9a1532",
  null
  
)

export default component.exports